import { Component } from "../base/Component";
import { ComponentFactory } from "../../service/ComponentFactory";
import { DomUtil } from "../../util/DomUtil";
import { EventUtil } from "../../util/EventUtil";
import { ILandingCardLayoutLoadedDetail, LandingCardLayout } from "./LandingCardLayout";
import { moduletracking } from "../../Wyanoke/ModuleTracking";
import { WyanokeUtil } from "../../util/WyanokeUtil";

export class LandingCardLoader extends Component {

  public static readonly LoadPageEvent = "LandingCardLoaderLoadPageEvent";
  public static readonly LoadMoreEvent = "LandingCardLoaderLoadMoreEvent";
  public static readonly ChangePageEvent = "LandingCardLoaderChangePageEvent";
  public static readonly LoadFilteredPageEvent = "LandingCardLoaderFilteredPageEvent";

  private readonly _paginationContainer: HTMLElement;
  private readonly _loadMoreTemplate: string;
  private readonly _working: HTMLElement;
  private readonly _emptyStateContainer: HTMLElement;

  constructor(element: HTMLElement) {
    super(element);

    const fragment = document.createDocumentFragment();
    this._working = fragment.appendChild(document.createElement("div"));

    const query = DomUtil.query.bind(null, element);
    const template =
      (name: string) => query(`[data-template='${name}']`).innerHTML;

    this._paginationContainer = query("[data-container='pagination']");
    this._emptyStateContainer = query("[data-container='empty-state']");
    this._loadMoreTemplate = template("load more");

    this._element.addEventListener("click", ev => this.handleClick(ev));

    document.addEventListener(
      LandingCardLayout.LandingCardLayoutLoadedEvent,
      ev => this.handleLoad(ev as CustomEvent<ILandingCardLayoutLoadedDetail>));

    this.render();
  }

  private get currentPage(): number | null {
    const raw = this._element.dataset.currentPage || "";
    const parsed = parseInt(raw, 10);

    return isNaN(parsed) ? null : parsed;
  }

  private get totalPages(): number | null {
    const raw = this._element.dataset.totalPages || "";
    const parsed = parseInt(raw, 10);

    return isNaN(parsed) ? null : parsed;
  }

  private handleLoad(ev: CustomEvent<ILandingCardLayoutLoadedDetail>): void {
    if(ev?.detail?.current === undefined || ev?.detail?.total === undefined) {
      return;
    }
    this._element.dataset.currentPage = ev.detail.current.toString();
    this._element.dataset.totalPages = ev.detail.total.toString();
    
    // Handle empty state
    if (ev.detail.isEmpty) {
      this.showEmptyState();
    } else {
      this.hideEmptyState();
    }
    
    this.render();
  }

  private handleClick(ev: MouseEvent): void {
    let cursor = ev.target as HTMLElement;
    while (cursor !== this._element && !cursor.hasAttribute("data-action")) {
      cursor = cursor.parentElement as HTMLElement;
    }

    switch (cursor.dataset.action) {
      case "load more":
        this.loadMore(this.currentPage === null ? 1 :
          this.currentPage + 1);
        break;

      case "first-page":
        this.loadPage(this.currentPage === null ? 1 :
          this.currentPage - this.currentPage);
        break;

      case "last-page":
        this.loadPage(this.totalPages === null ? 1 :
          this.totalPages);
        break;

      case "previous":
        this.loadPage(this.currentPage === null ? 1 :
          this.currentPage - 1);
        break;

      case "next":
        this.loadPage(this.currentPage === null ? 1 :
          this.currentPage + 1);
        break;

      case "load page":
        this.loadPage(parseInt(cursor.dataset.page || "", 10));
        break;

      default:
        return;
    }

    ev.preventDefault();
    ev.stopPropagation();
  }

  private loadMore(page: number): void {
    this._element.dispatchEvent(
      EventUtil.createCustomEvent(LandingCardLoader.LoadMoreEvent, page));
  }

  private loadPage(page: number): void {
    this._element.dispatchEvent(
      EventUtil.createCustomEvent(LandingCardLoader.LoadPageEvent, page));
  }

  private render(): void {
    while (this._paginationContainer.firstChild) {
      this._paginationContainer.firstChild.remove();
    }

    this.renderLoadMore();
    $(function ():void {
      if (WyanokeUtil.isMobile()){
        $("div[data-component='LandingCardFeatured']")
          .insertAfter("nav[data-component='LandingCardLoader']");
      }
    });

    moduletracking.AjaxTrackLinks(this._element,"LandingCardLoader");
  }

  private renderLoadMore(): void {
    const shouldDisplay =
      this.currentPage !== null &&
      this.totalPages !== null &&
      this.currentPage < this.totalPages;

    if (!shouldDisplay) {
      return;
    }

    this.add(this._loadMoreTemplate);
  }

  private add(html: string | null): void {
    if (html) {
      this._working.innerHTML = html;
      const element = this._working.firstElementChild;
      if (element) {
        this._paginationContainer.appendChild(element);
      }
    }
  }

  private showEmptyState(): void {
    if (this._emptyStateContainer) {
      this._emptyStateContainer.style.display = "block";
    }
  }

  private hideEmptyState(): void {
    if (this._emptyStateContainer) {
      this._emptyStateContainer.style.display = "none";
    }
  }
}

ComponentFactory.registerComponent("LandingCardLoader", LandingCardLoader);
